<template>
  <div class="controlpanel-page">
    <h1>首页内容更新</h1>
    <el-divider></el-divider>
    <div class="controlpanel-container">
      <el-row :gutter="30">
        <el-col :span="12">
          <div class="radioline">
            <el-radio-group v-model="infolang" size="medium">
              <el-radio-button label="cn">中文</el-radio-button>
              <el-radio-button label="en">English</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="messagetype" size="medium">
              <el-radio-button label="main">Welcome</el-radio-button>
              <el-radio-button label="update">Update</el-radio-button>
            </el-radio-group>
          </div>

          <el-form class="formbox">
            <el-form-item>
              <el-input
                type="textarea"
                :rows="16"
placeholder="内容编辑格式示例如下：
1、段落必须以'<p>'开头并以'</p>'，例如<p>这是一个段落，结尾</p>
2、文字颜色：<span style='color:rgb(0,0,0);'>这里是需要上色的文字</span>
3、段中换行：在需要换行的地方添加<br/>标签
4、段落文字默认居左，如需设置居中/右，在段落前部的<p>标签添加样式
如：<p style='text-align:right;'>，左中右分别对应left/center/right
5、邮箱链接<a href='mailto:邮箱地址'>邮箱地址</a>
6、站外链接，例如链接到百度：<a href='https://baidu.com' target='_blank'>百度</a>
7、Update列表
<ul>
  <li>这里是一条信息</li>
  <li>这里是第二条信息</li>
  <li>...</li>
  <li>类推</li>
</ul>"
                v-model="message">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="info" @click="clearMessage()">清 除</el-button>
              <el-button type="primary" @click="onClick()">提 交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <h2 class="previewboxtitle">预览</h2>
          <div class="home-page-content previewbox" v-html="message"></div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      infolang: '',
      messagetype: '',
      message: ''
    }
  },
  methods: {
    
    clearMessage: function(){
      this.message = ''
    },

    onClick: function(){
      let that = this;
      if(that.infolang === '') return
      if(that.messagetype === '') return
      if(that.message === '') return
      let url = 'http://dashboard.api.trade-intelligence.com/basic/admin/homemessage'+'?token='+that.getLocalStorage('admintoken')+'';
      let datamessage = {
        message: that.message,
        type: that.messagetype,
        lang: that.infolang
      }
      console.log(that.getLocalStorage('admintoken'))
      console.log("Intro Info", datamessage)
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(datamessage),
        contentType: "application/json",
        success: function(data) {
          console.log('success', data)
          if(data.code === 200){
            that.$message({
              duration: 0,
              offset: 80,
              showClose: true,
              message: data.error,
              type: 'success'
            })
          }else{
            that.$message({
              duration: 0,
              offset: 80,
              showClose: true,
              message: data.error,
              type: 'error'
            })            
          } 
        },
        error: function(response) {
          console.log('error', response)
        }
      })
    },
  }
}
</script>

<style scoped>
  .formbox{
    margin-top: 20px;
  }
  .previewboxtitle{
    font-size: 16px;
    line-height: 36px;
    font-weight: normal;
  }
  .previewbox{
    background-color: rgb(51,63,80);
    margin-top: 20px;
    padding: 10px;
    min-height: 340px;
  }
  .radioline .el-radio-group{
    margin-right: 20px;
  }
</style>